import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import '../../scss/cabinet-index.scss';

import '../../common';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from '../store';
import App from './App.jsx';

ReactDOM.render(<BrowserRouter>
    <Provider store={ store }>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root'));
